import React, { Component } from 'react'
import queryString from 'query-string'
import EnhancedEvent from '../helpers/EnhancedEvent'
import EnhancedEvents from '../helpers/EnhancedEvents'
import EnhancedEventStreamer from '../helpers/EnhancedEventStreamer'
import App from './App'
import Error from './Error'

const { v4: uuidv4 } = require('uuid');
const forge = require('node-forge');

const PERMISSIONS_SIGNATURE_PUBLIC_KEY =
    '-----BEGIN PUBLIC KEY-----\n' +
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9rKmlDkshBt9wvtmaWHyiIVXJ\n' +
    'cg3XPnbUF76q8SDfT43EQMwPiw/cy93xESs3E7LRPODUNVdJh7GijEbpENeCorwW\n' +
    'oM3fXOrQgdC9G9cJgkx/myieOobbLxQkVdrpO331cKByQD9GQ3NRfKsEyIFIRwod\n' +
    '1UFG96QQbnH4bDXSswIDAQAB\n' +
    '-----END PUBLIC KEY-----';


class AppContainer extends Component {
    constructor (props) {
        super(props)
        const release = process.env.REACT_APP_RELEASE
        const environment = process.env.REACT_APP_STAGE
        const journey = uuidv4()

        const query = queryString.parse(window.location.search)
        const session = query.data
        const orgId = query.orgId
        const orgType = query.orgType
        const ratingOptions = query.rating_opts !== undefined ? JSON.parse(query.rating_opts) : {ratingType: '', ratingValue: 0}
        const clientActionId = query.aid;
        const timestamp = query.timestamp;
        const permsSignature = query.perms_sign;

        let perms = [];
        if (this.isSignedParamVerifiedSHA1(query.perms + clientActionId + timestamp, permsSignature, PERMISSIONS_SIGNATURE_PUBLIC_KEY)) {
            perms = query.perms.split(";");
        }

        this.state = {
            release: release,
            environment: environment,
            uri: query.src,
            session: session,
            journey: journey,
            error: null,
            errorEventId: null,
            referrer: query.referrer,
            clientActionId: clientActionId,
            startTimestamp: timestamp,
            permsSignature: permsSignature,
            viewerPermissions: {
                copy: perms.includes("copy-paste"),
                download: perms.includes("download"),
                print: perms.includes("print"),
                rate: perms.includes("rate"),
                relatedResearch: perms.includes('related-research')
            },
            ratingOptions: {
                type: ratingOptions.ratingType,
                currentScore: parseInt(ratingOptions.ratingValue, 10),
                rated: false
            }
        }

        EnhancedEvents.init()
        EnhancedEventStreamer.init(EnhancedEvents, {
            session: session,
            journey: journey,
            release: release,
            environment: environment,
            resourceUrl: query.src,
            orgId: orgId,
            orgType: orgType
        })
        EnhancedEventStreamer.schedule()

        this.addEnhancedEvent('NAVIGATION_START', { timestamp: window.performance.timing.navigationStart });
        this.addEnhancedEvent('APP_INIT_START', undefined);
    }

    componentDidMount () {
        this.addEnhancedEvent('APP_MOUNT', undefined);
    }

    addEnhancedEvent = (eventType, extraParams) => {
        let eventConfig = { type: eventType, page: -1 };
        if (extraParams) {
            eventConfig = Object.assign(eventConfig, extraParams);
        }

        EnhancedEvents.add(new EnhancedEvent(eventConfig))
    }

    isSignedParamVerifiedSHA1 = (param, signature, publicKeyString) => {
        if (!param || !signature) return;

        let publicKey = forge.pki.publicKeyFromPem(publicKeyString);
        let md = forge.md.sha1.create();
        md.update(param, 'utf8');
        return publicKey.verify(md.digest().bytes(), forge.util.decode64(signature));
    }

    componentDidCatch (error, errorInfo) {
        this.handleError(error, null);
    }

    fallback () {
        try {
            this.addEnhancedEvent('FALLBACK', undefined);
        } catch (e) {
            console.error('Could not add event', e)
        }
    }

    handleError = (message, e) => {
        this.fallback()
        this.setState({
            error: message,
            errorEventId: '<<>>'
        })
    }

    render () {
        return (
            <div className="AppContainer">
                {!this.state.error &&
                <App release={this.state.release} environment={this.state.environment} uri={this.state.uri} enhancedEvents={EnhancedEvents} onError={this.handleError}
                     viewerPermissions={this.state.viewerPermissions} referrer={this.state.referrer} clientActionId={this.state.clientActionId}
                     startTimestamp={this.state.startTimestamp} permsSignature={this.state.permsSignature} ratingOptions={this.state.ratingOptions} />
                }
                {this.state.error &&
                <Error error={this.state.error} eventId={this.state.errorEventId} release={this.state.release} fallbackRedirect={this.state.uri} environment={this.state.environment} />
                }
            </div>
        )
    }
}

export default AppContainer
